module.exports = __webpack_public_path__ + "assets/img/bcc0-th.svg";